// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// TODO: Connect with backend with Page size from the CMS

export interface SocialMediaModel {
    id: string;
    imageUrl: string;
    postUrl: string;
}

const W = 240;
const H = 240;
const STATIC_POSTS: SocialMediaModel[] = [
    { id: "1", imageUrl: `https://picsum.photos/id/1025/${W}/${H}`, postUrl: "#" },
    { id: "2", imageUrl: `https://picsum.photos/id/1018/${W}/${H}`, postUrl: "#" },
    { id: "3", imageUrl: `https://picsum.photos/id/1015/${W}/${H}`, postUrl: "#" },
    { id: "4", imageUrl: `https://picsum.photos/id/1003/${W}/${H}`, postUrl: "#" },
    { id: "5", imageUrl: `https://picsum.photos/id/1011/${W}/${H}`, postUrl: "#" },
    { id: "6", imageUrl: `https://picsum.photos/id/1020/${W}/${H}`, postUrl: "#" },
];

// import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
// const socialMediaUrl = "/api/synd/social/instagram/posts";
// type PostsResponse = { posts: SocialMediaModel[] };

export async function getSocialMediaPosts(pageSize: number): Promise<SocialMediaModel[]> {
    return STATIC_POSTS;

    // When backend is ready
    // const res = await get<PostsResponse>(socialMediaUrl, {} as ApiParameter);
    // return Array.isArray(res?.posts) ? res.posts : [];
}
